import { Autocomplete, Box, TextField } from '@mui/material';
import { StatusDot } from 'greener-ui-library';
import useUnitsConnectionStatus from 'hooks/useUnitsConnectionStatus';
import { DEVICE_TYPES, DEVICE_TYPE_IDS } from 'utils/constants';

export default function UnitSelector({
  units,
  handleChange,
  selectedUnitExtId,
  unitType,
  fieldLabel,
}: {
  units: any[];
  handleChange?: (unit: any) => void;
  selectedUnitExtId?: string;
  unitType?: string;
  fieldLabel?: string;
}) {
  if (!units || units.length === 0) {
    return null;
  }

  const unitStatuses = useUnitsConnectionStatus();

  const deviceTypeId = unitType === DEVICE_TYPES.BATTERY ? DEVICE_TYPE_IDS.BATTERY : DEVICE_TYPE_IDS.ENERGY_METER;

  const filteredUnits = unitType
    ? units.filter((unit) =>
        [unit.watcherType.deviceTypeId, unit.watcherType.deviceType?.deviceTypeId].includes(deviceTypeId)
      )
    : units;

  const selectedUnit = filteredUnits.find((unit) => unit && unit.externalIdentifier === selectedUnitExtId) || {};

  const onChangeUnit = (unit) => {
    unit && handleChange && unit.externalIdentifier && handleChange(unit);
  };

  function getOptionLabel(option: { externalIdentifier?: string; name?: string }) {
    return `${option?.externalIdentifier} | ${option?.name}`;
  }

  return (
    <Autocomplete
      id="autocomplete-unit-selector"
      data-testid="autocomplete-unit-selector"
      value={selectedUnit}
      options={filteredUnits}
      getOptionLabel={getOptionLabel}
      onChange={(_, value) => {
        onChangeUnit(value);
      }}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        const isOnline = unitStatuses[option.externalIdentifier!];
        return (
          <Box key={key} component="li" {...rest} sx={{ display: 'flex', alignItems: 'center' }}>
            <StatusDot color={isOnline ? 'primary.main' : 'grey.300'} sx={{ mr: 1 }} />
            <span>
              {option.externalIdentifier} | {option.name}
            </span>
          </Box>
        );
      }}
      disableClearable
      renderInput={(params) => {
        const isOnline = unitStatuses[selectedUnit.externalIdentifier!];
        return (
          <TextField
            {...params}
            name="unit-selector"
            label={fieldLabel}
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            size="small"
            InputProps={{
              ...params.InputProps,
              startAdornment: <StatusDot color={isOnline ? 'primary.main' : 'grey.300'} sx={{ ml: '10px' }} />,
            }}
          />
        );
      }}
    />
  );
}
